import { Component } from "@angular/core";
import {
  ClientPromiseLookupService,
  UserPromiseLookupService,
  ClientActionPromiseService,
} from "shared/cubiq-services";
import { UserImpl, ClientImpl } from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";
import { BfxBlotterOrdersActionService } from "../bfx-blotter-orders/bfx-blotter-orders-action.service";

enum BfxClientTraderEditComponentFields {
  Client,
  Name,
  Comment,
  Desk,
  Mobile,
  Email,
}

enum BfxClientTraderEditComponentValidationResult {
  NotValidated,
  Valid,
  Invalid,
}

const REGEX_EMAIL =
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const REGEX_PHONE = /^\+?[0-9]{3,}$/i;

const MANDATORY_FIELDS: Array<BfxClientTraderEditComponentFields> = [
  BfxClientTraderEditComponentFields.Name,
];
const OPTIONAL_FIELDS: Array<BfxClientTraderEditComponentFields> = [
  BfxClientTraderEditComponentFields.Email,
];
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-client-trader-edit",
  templateUrl: "./html/bfx-client-trader-edit.html",
  standalone: false,
})
export class BfxClientTraderEditComponent {
  public parentPopup: GoldenLayoutPopout;

  public clientTrader: UserImpl = new UserImpl();

  public client: ClientImpl;

  public callback: any;

  public callbackClose: any;

  public locked: boolean = false;

  public valid: any = {};

  constructor(
    public clientService: ClientPromiseLookupService,
    public userService: UserPromiseLookupService,
    public translationService: TranslateService,
    public blotterOrderService: BfxBlotterOrdersActionService,
    public clientActionService: ClientActionPromiseService,
  ) {}

  public glInit(data: any, container: any, state: any): void {
    this.clientTrader = Object.assign(
      new UserImpl(),
      data.clientTrader != null ? data.clientTrader : new UserImpl(),
    );
    this.client = data.client;
    this.callback = data.callback;
    this.callbackClose = data.callbackClose;
    this.clientTrader.clientCode = this.client.clientId;

    if (data.clientTrader != null) {
      this.validateAll();
    }
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopup = parentPopup;
    this.parentPopup.setShowDock(false);
    this.parentPopup.setShowRefresh(false);
  }

  save() {
    if (this.validateAll()) {
      this.callback(this.clientTrader);
      this.parentPopup.close();
    }
  }

  isSaveEnabled(): boolean {
    let mandatory: boolean = MANDATORY_FIELDS.every(
      (field: BfxClientTraderEditComponentFields) =>
        this.valid[field] == BfxClientTraderEditComponentValidationResult.Valid,
    );
    let optional: boolean = OPTIONAL_FIELDS.every(
      (field: BfxClientTraderEditComponentFields) =>
        this.valid[field] != BfxClientTraderEditComponentValidationResult.Invalid,
    );
    return mandatory && optional;
  }

  cancel() {
    this.parentPopup.close();
  }

  validateAll(): boolean {
    let valid: boolean = true;

    for (let i: number = 1; i <= 5; i++) {
      valid = this.validate(i) && valid;
    }

    return valid;
  }

  validate(fieldNo: BfxClientTraderEditComponentFields): boolean {
    let valid: boolean = true;
    let state = BfxClientTraderEditComponentValidationResult.NotValidated;

    switch (fieldNo) {
      case BfxClientTraderEditComponentFields.Name:
        valid = this.clientTrader.userName != null && this.clientTrader.userName.trim().length > 0;
        state = valid
          ? BfxClientTraderEditComponentValidationResult.Valid
          : BfxClientTraderEditComponentValidationResult.Invalid;
        break;
      case BfxClientTraderEditComponentFields.Comment:
        if (this.clientTrader.comment != null && this.clientTrader.comment.length > 0) {
          state = BfxClientTraderEditComponentValidationResult.Valid;
        }
        break;
      case BfxClientTraderEditComponentFields.Desk:
        if (this.clientTrader.desk != null && this.clientTrader.desk.length > 0) {
          state = BfxClientTraderEditComponentValidationResult.Valid;
        }
        break;
      case BfxClientTraderEditComponentFields.Mobile:
        if (this.clientTrader.smsNumber != null && this.clientTrader.smsNumber.length > 0) {
          valid = this.smsValid();
          state = valid
            ? BfxClientTraderEditComponentValidationResult.Valid
            : BfxClientTraderEditComponentValidationResult.Invalid;
        }
        break;
      case BfxClientTraderEditComponentFields.Email:
        if (this.clientTrader.emailAddress != null && this.clientTrader.emailAddress.length > 0) {
          valid = this.emailValid();
          state = valid
            ? BfxClientTraderEditComponentValidationResult.Valid
            : BfxClientTraderEditComponentValidationResult.Invalid;
        }
        break;
      default:
        // TODO check for null/length==0
        state = BfxClientTraderEditComponentValidationResult.Valid;
        break;
    }

    this.valid[fieldNo] = state;

    return state != BfxClientTraderEditComponentValidationResult.Invalid;
  }

  emailValid(): boolean {
    return (
      this.clientTrader.emailAddress != null && REGEX_EMAIL.test(this.clientTrader.emailAddress)
    );
  }

  smsValid(): boolean {
    return this.phoneValid(this.clientTrader.smsNumber);
  }

  phoneValid(phoneEntry: string): boolean {
    return phoneEntry != null && REGEX_PHONE.test(phoneEntry);
  }

  public onClose(event: any): void {
    if (this.callbackClose) {
      this.callbackClose(event);
    }
  }
}
